"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_brand_1 = require("@giphy/js-brand");
var css_1 = require("@emotion/css");
var preact_1 = require("preact");
// trying to share css from brand, but this has an element structure
// so it's ugly. will probably move the css in here
exports.default = (function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return ((0, preact_1.h)("div", { className: (0, css_1.cx)(js_brand_1.loader, className) },
        (0, preact_1.h)("div", null),
        (0, preact_1.h)("div", null),
        (0, preact_1.h)("div", null),
        (0, preact_1.h)("div", null),
        (0, preact_1.h)("div", null)));
});
//# sourceMappingURL=loader.js.map